export class Location {

    Name: string;
    Lat: number;
    Lng: number;
    Marker: any;

    constructor(init?: Partial<Location>) {
        Object.assign(this, init);

        if (init && !init.Lat) {
            this.Lat = 51.507351;
        };

        if (init && !init.Lng) {
            this.Lng = -0.127758;
        };
    };
}



// WEBPACK FOOTER //
// ./src/app/common/location.ts